import { SVG_GetDefs } from "./SVG_GetDefs";
import { NS_SVG } from "../constants";

export function SVG_AddGradient(idStr, fillColor, backColor, svgElement) {
  var defs = SVG_GetDefs(svgElement);
  var gradient = document.createElementNS(NS_SVG, "linearGradient");
  gradient.setAttribute("id", idStr);
  gradient.setAttribute("x1", "0%");
  gradient.setAttribute("y1", "0%");
  gradient.setAttribute("x2", "0%");
  gradient.setAttribute("y2", "100%");
  var stop1 = document.createElementNS(NS_SVG, "stop");
  stop1.setAttribute("offset", "0%");
  stop1.setAttribute("stop-color", fillColor);
  var stop2 = document.createElementNS(NS_SVG, "stop");
  stop2.setAttribute("offset", "100%");
  stop2.setAttribute("stop-color", backColor);
  defs.appendChild(gradient);
  gradient.appendChild(stop1);
  gradient.appendChild(stop2);
}
